import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Table from "react-bootstrap/Table";
import { useDispatch } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { numOfPage } from '../../constant';
import { requestHistory } from '../../store/actions/batch.action';
import LoaderSpinner from '../common/Loader';
import moment from 'moment';
import _ from 'lodash';

/* istanbul ignore next */
const RequestHistory = (props) => {
    const { isSearch, setIsSearch, isReset, filterAction, filterDataObj, setFilterAction, setfilterDataObj } = props;
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = React.useState(false);
    const [historyData, setHistoryData] = React.useState([]);
    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        sellerIdList: [],
        companyIdList: [],
        showFilter: false,
        showSearch: false,
        isSearch: isSearch || false,
    };

    useEffect(() => {
        if (filterAction) {
            handleFilterUpdate();
        }
    }, [filterAction]);

    const [filterData, setfilterData] = useState({ ...dataLoad });

    const fetchRequestHistory = async () => {
        let data = {};
        if (filterAction === 'reset') {
            data = { ...dataLoad }
        } else {
            data = {
                ...filterData,
                searchText: props?.searchTxt || '',
                sellerIdList: _.map(filterDataObj?.sellerIdList, 'value') || [],
                companyIdList: _.map(filterDataObj?.companyIdList, 'value') || [],
                carrierIdList: _.map(filterDataObj?.carrierIdList, 'value') || [],
                serviceIdList: _.map(filterDataObj?.serviceIdList, 'value') || [],
                statusIdList: _.map(filterDataObj?.statusIdList, 'value') || [],
            }
        }
        try {
            setShowLoader(true);
            const response = await Promise.resolve(dispatch(requestHistory(data)));
            if (response?.data?.Status === 200) {
                setHistoryData(response?.data?.EntityList);
                setfilterData({ ...filterData, TotalRecords: response?.data?.TotalRecords, totalPages: Math.ceil(response?.data?.TotalRecords / (filterData?.pageSize || 30)) });
                setShowLoader(false);
            } else {
                setShowLoader(false);
                console.error("Error fetching request history:", response.data.Message);
            }
        } catch (error) {
            console.error("Error fetching request history:", error);
            setShowLoader(false);
        }
    };

    const handleSearch = async () => {
        let data = {
            ...dataLoad,
            searchText: props?.searchTxt || '',
        }
        try {
            setShowLoader(true);
            const response = await Promise.resolve(dispatch(requestHistory(data)));
            if (response?.data?.Status === 200) {
                setHistoryData(response?.data?.EntityList);
                setfilterData({ ...filterData, TotalRecords: response?.data?.TotalRecords, totalPages: Math.ceil(response?.data?.TotalRecords / (filterData?.pageSize || 30)) });
                setShowLoader(false);
            } else {
                setShowLoader(false);
                console.error("Error fetching request history:", response.data.Message);
            }
            setIsSearch(false);
        } catch (error) {
            console.error("Error fetching request history:", error);
            setIsSearch(false);
            setShowLoader(false);
        }
    }

    useEffect(() => {
        if (isSearch || isReset) {
            handleSearch();
        }
    }, [isSearch, isReset]);

    useEffect(() => {
        fetchRequestHistory();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

    const getStatusClass = (status) => {
        if (status.includes('Cancellation In-Progress')) {
            return 'activeStatus activeStatusInprogress';
        } else if (status.includes('Refunded')) {
            return 'activeStatus activeStatusRefunded';
        } else {
            return 'activeStatus';
        }
    };

    const handleFilterUpdate = () => {
        if (filterAction === 'apply') {
            let data = {
                ...filterData,
                pageIndex: 1,
            };
            setfilterData(data);
            if (filterData.pageIndex === 1) {
                fetchRequestHistory();
            }
        } else if (filterAction === 'reset') {
            setfilterDataObj({});
            let data = {
                ...filterData,
                pageIndex: 1,
            };
            setfilterData(data);
            if (filterData.pageIndex === 1) {
                fetchRequestHistory();
            } else {
                setfilterData({ ...dataLoad, pageIndex: 1 });
            }
        }
        setFilterAction('');
    }

    return (
        <div className='queryBox1'>
            {showLoader && <LoaderSpinner />}
            <div className="refundTable tableFixHead incomingTbl">
                <Table className="tableWide table-height">
                    <thead className='tbl-btch'>
                        <tr className='table-rw-batch'>
                            <th className="head-company">Company/Seller</th>
                            <th className="">Service Name/Package Name</th>
                            <th>Carrier</th>
                            <th className="">Tracking Number</th>
                            <th>Label Creation Date</th>
                            <th>Refund Request Date</th>
                            <th>Order/Reference Number</th>
                            <th>Refund Reason</th>
                            <th>Receiver</th>
                            <th className='sticky'>Shipment Status</th>
                        </tr>
                    </thead>
                    <tbody className='tbl-bt-body'>
                        {historyData.map((d) => (
                            <tr key={d?.TrackingNumber}>
                                <td className='taskTitle' width={'10%'}>{d?.CompanySellerName}</td>
                                <td>{d?.ServiceName} / <br /> {d?.PackageName}</td>
                                <td className='' width={'8%'}>{d?.CarrierCompanyName}</td>
                                <td className='taskTitle' width={'5%'}>{d?.TrackingNumber}</td>
                                <td>
                                    {moment(d?.LabelCreationDate).format(
                                        "MM-DD-YYYY | h:mm:ss A"
                                    )}
                                </td>
                                <td>
                                    {moment(d?.RefundRequestDate).format(
                                        "MM-DD-YYYY | h:mm:ss A"
                                    )}
                                </td>
                                <td>
                                    {d?.OrderNumber}
                                    <div className="wordWrap">{d?.Note}</div>
                                </td>
                                <td className='reasonField'>{d?.RefundReason}</td>
                                <td width={'15%'} >
                                    <div>{d?.ReceiverName}</div>
                                    {d.ReceiverAddressLine1} {d.ReceiverAddressLine2} {d.ReceiverCity}{" "}
                                    {d.ReceiverState} {d.ReceiverZip}{" "}
                                    {d.ReceiverCountryCode}
                                </td>
                                <td className='sticky'>
                                    <span className={getStatusClass(d.ShipmentStatus)}>
                                        {d.ShipmentStatus ? d.ShipmentStatus : "Booked"}
                                    </span>
                                </td>
                            </tr>
                        ))}
                        {!historyData.length && (
                            <tr>
                                <td colSpan={"11"} align="center">
                                    No Record Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <BatchPagination
                gridData={historyData}
                totalVisualRecords={historyData.length}
                numberOfPage={filterData.pageSize}
                numOfPage={numOfPage}
                currentPage={filterData.pageIndex}
                totalPages={filterData.totalPages}
                totalRecords={filterData?.TotalRecords}
                loader={showLoader}
                setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
            />
        </div >
    );
}

RequestHistory.propTypes = {
    isSearch: PropTypes.bool,
    setIsSearch: PropTypes.func,
    isReset: PropTypes.bool,
    filterAction: PropTypes.string,
    filterDataObj: PropTypes.object,
    setFilterAction: PropTypes.func,
    setfilterDataObj: PropTypes.func,
    searchTxt: PropTypes.string
};

export default RequestHistory;